import { getDomainName } from '../../../../utils/aem-utils';
import { setCookie, getCookie, removeCookie } from '../../../../utils/cookies';

const PREFERENCES_COOKIE_NAME = '_parsely_preferences';

const preferenceBelongsToWidget = (userPreferenceName, widgetPreferences) =>
  widgetPreferences.map((widgetPref) => widgetPref.name).includes(userPreferenceName);

export const setPreferencesCookie = (userPreferences, widgetPreferences, consent) => {
  const currentCookieValue = getCookie(PREFERENCES_COOKIE_NAME) || '';

  // We want to save other preferences not belonging this widget
  const currentOtherWidgetsPreferencesNames =
    currentCookieValue && currentCookieValue !== 'null'
      ? currentCookieValue
          .split('|')
          .map((singleValue) => singleValue.split('-')[1])
          .filter((userPreferenceName) => !preferenceBelongsToWidget(userPreferenceName, widgetPreferences))
      : [];

  const newWidgetPreferencesNames = userPreferences?.map((userPreference) => userPreference.name);
  const newCookieValue =
    [...newWidgetPreferencesNames, ...currentOtherWidgetsPreferencesNames]
      .map((userPreferenceName) => `${getDomainName()}-${userPreferenceName}`)
      .join('|') || null;
  if (consent) {
    setCookie(PREFERENCES_COOKIE_NAME, newCookieValue);
  } else {
    removeCookie(PREFERENCES_COOKIE_NAME);
  }
};
